"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ON_NAV_OPEN = exports.ON_NAV_CLOSE = void 0;
var ON_NAV_OPEN = exports.ON_NAV_OPEN = 'ON_NAV_OPEN';
var ON_NAV_CLOSE = exports.ON_NAV_CLOSE = 'ON_NAV_CLOSE';